import React from "react";
import styled from "styled-components";
import "swiper/components/pagination/pagination.min.css";
// import "./styles.css";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper.min.css";
import data from "../data/rushdata.json";

SwiperCore.use([Autoplay, Pagination]);

const HwtSlider1 = () => {
  return (
    <Wrapper>
      <Swiper
        // pagination={true}
        className="mySwiper"
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
      >
        {data.hwtSliderfirst.map(({ id, image }) => (
          <SwiperSlide key={id}>
            <div className="sliderImgWrapper">
              <img className="sliderImg" src={image} alt="s" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100% !important;
  overflow: hidden;
  margin: 20px !important;
  .sliderImgWrapper {
    width: 100% !important;
    overflow: hidden !important;
    .sliderImg {
      width: 100% !important;
      overflow: hidden !important;
      padding: 0 27px 0 0;
    }
  }
  .swiper-container-horizontal
    > .swiper-pagination-bullets
    .swiper-pagination-bullet {
    margin: 0 4px;
    width: 10px;
    height: 5px;
    border-radius: 5px;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 4px;
    left: -14px;
    width: 100%;
  }
  .swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 1;
    padding: 20px 0;
  }
`;

export default HwtSlider1;
